import React from 'react';

import themeGet from '@styled-system/theme-get';
import useGoogleEcommerce from 'helpers/google-ecommerce/hooks/use-google-ecommerce';
import * as T from 'prop-types';
import styled from 'styled-components/macro';

import { Flex, Link, Text } from '@olist/united';

const InfoText = (props) => <Flex flexDirection="column" p={3} mt={6} {...props} />;

const Title = (props) => <Text.H3 fontWeight="semibold" lineHeight="1.2" {...props} />;

const Description = styled(Text)`
  line-height: 1.5;
  margin-top: ${themeGet('space.3')}px;
  max-width: 432px;
`;

const StepContent = ({
  callToAction,
  description,
  href,
  image,
  infoTextProps,
  title,
  ...props
}) => {
  const { setProductClick } = useGoogleEcommerce('onboarding', 'first-steps', '3');

  const btnClick = () => {
    const { id } = props;
    if (id) {
      setProductClick([id]);
    }
  };

  return (
    <Flex flexDirection="column" data-testid="step-content" {...props}>
      {React.isValidElement(image) && image}
      <InfoText {...infoTextProps}>
        <Title>{title}</Title>
        <Description>{description}</Description>
        {href && (
          <Flex mt={4}>
            <Link variation="alternate" href={href} onClick={btnClick}>
              {callToAction}
            </Link>
          </Flex>
        )}
      </InfoText>
    </Flex>
  );
};

StepContent.defaultProps = {
  href: null,
  id: null,
  infoTextProps: {},
  description: '',
};

StepContent.propTypes = {
  /**
   * What is the call to action text?
   */
  callToAction: T.string.isRequired,
  /**
   * What is the description of the step?
   */
  description: T.node,
  /**
   * What page does it link to?
   */
  href: T.string,
  /**
   * What is the illustrative image of the step?
   */
  image: T.node.isRequired,
  /**
   * What is the title of the step?
   */
  title: T.string.isRequired,
  id: T.string,
  infoTextProps: T.shape({}),
};

export default styled(StepContent)``;
